module.exports = __webpack_public_path__ + "img/4-section-model-sr.cf767d73.jpeg";